import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingScreen } from '../components/LoadingScreen';

/**
 * Renders children only for AMMINISTRATORE_AZIENDA.
 * Otherwise redirects to /app/worksites.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'AMMINISTRATORE_AZIENDA') {
    return <Navigate to="/app/worksites" replace />;
  }

  return <>{children}</>;
}
